import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useAppContext } from 'src/context/useAppContext';

import { selectPayment } from 'src/store/slice/payment/state';

import './currency-fee.scss';

const CurrencyFee: React.FC = (): JSX.Element | null => {
  const { t } = useTranslation();

  const payment = useSelector(selectPayment);
  
  const isPassthroughIncluded = payment?.passthrough_fees;
  const parentMerchantFeeAmount = payment?.parent_merchant_fee_amount;

  const { currency } = useAppContext();

  const { currency_id: selectedCurrencyId } = currency;
  const { fees_values } = payment || {};

  const currentFee = fees_values?.find((fee: any) => fee.currency_id === selectedCurrencyId);

  const depositFeePercent = Number(((currentFee?.deposit_fee || 0) * 100).toFixed(2));
  const depositFlatFee = currentFee?.deposit_flat_fee || 0;

  // Don't show if no fee data
  if(!parentMerchantFeeAmount || isPassthroughIncluded) return null;

  return (
    <p className="currency-fee">
      {depositFlatFee > 0
        ? t('TRANSACTION.DEPOSIT_FEE_INFO_WITH_MIN', {
            fee_percent: depositFeePercent,
            min_fixed: depositFlatFee,
            currency: selectedCurrencyId,
          })
        : t('TRANSACTION.DEPOSIT_FEE_INFO', {
            fee_percent: depositFeePercent,
          })}
    </p>
  );
};

export default CurrencyFee;
